<template>
<section class="public-page page-wraper">
  <!-- <myTitle :title="'公示'"></myTitle> -->
  <div class="main-wraper">
    <div class="public-type">
      <p style="color: #409EFF;">tips：发布公示需要将小智更新到最新版使用哦(点击小智左下角设置后点击检查更新)！填完详细地址后再提交哦（详细地址必填）！</p>
      帖子分类：
      <el-radio-group v-model="radio">
        <el-radio :label="item.id" v-for="(item, index) in typeList" :key="index">{{item.name}}</el-radio>
      </el-radio-group>
    </div>
    <div class="public-type">
      截止日期：
      <el-date-picker
        size="mini"
        v-model="deadline"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="选择日期">
      </el-date-picker>
    </div>
    <div class="public-type">
      地区选择：
      <el-select size="mini" v-model="provinceValue" placeholder="请选择适用地区" v-on:input="searchArea(provinceValue)">
        <el-option
          v-for="(item, index) in areaList"
          :key="index"
          :label="item.pro"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="public-typeNew">
      具体地址：
      <el-select v-if="isCitySelf" size="mini" v-model="cityValue" placeholder="请选择所属市" v-on:input="searchCounty(cityValue)">
        <el-option
          v-for="(item, index) in cityList"
          :key="index"
          :label="item.city"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-if="isCountySelf" size="mini" v-model="countyValue" placeholder="请选择所属区县">
        <el-option
          v-for="(item, index) in countyList"
          :key="index"
          :label="item.area"
          :value="item.id">
        </el-option>
      </el-select>
      <el-input style="width:20%" v-model="townValue" size="mini" placeholder="请输入详细地址"></el-input>
    </div>
    <div class="public-title">
      标题：<el-input v-model.trim="publicTitle" size="mini" placeholder="请输入帖子标题" maxlength="80" show-word-limit></el-input>
    </div>
    <div class="public-typeNew">
      公示权限：
      <el-radio v-model="status" label="到期后持续展示">到期后持续展示</el-radio>
      <el-radio v-model="status" label="到期后持续展示，但不可下载附件">到期后持续展示，但不可下载附件</el-radio>
      <el-radio v-model="status" label="无限制">无限制</el-radio>
    </div>
    <div class="public-tip">
      tips：通常3小时内审完，不会超过24小时。若急，请通过左下角联系我们立即审核。 {{ tips }}
    </div>
    <div class="editor-wrap">
      <div id="wangeitor"></div>
    </div>
    <!-- <button @click="testApi">api test</button>
    <button @click="testApi1">api test1</button> -->
    <div class="public-action">
      <el-button size="mini" type="primary" @click="doPublish">提交</el-button>
      <el-button size="mini" @click="doSave">保存</el-button>
    </div>
  </div>
  <el-dialog
    center
    title="图片插入(png、jpg)"
    :visible.sync="showImgUpload"
    width="600px">
    <imgUplod v-if="showImgUpload" @dispachUrl="handleImgChange"></imgUplod>
  </el-dialog>
  <el-dialog
    center
    title="附件插入(pdf、excel、word、zip)"
    :visible.sync="showAttachUpload"
    width="600px">
    <attachUpload v-if="showAttachUpload || attachUploading" @uploadBegain="attachUploading = true" @dispachUrl="handleAttachChange"></attachUpload>
  </el-dialog>
</section>
</template>

<script>
// import myTitle from '@/components/myTitle.vue'
import imgUplod from '@/components/public/img-upload'
import attachUpload from '@/components/public/attach-upload'
import api from '../../api/index'
import E from 'wangeditor'
// import { remote } from 'electron'
const BtnMenu = E
export default {
  data () {
    const passwordSeA = JSON.parse(localStorage.getItem('password_se') || '{}')
    return {
      tips: '',
      status: '无限制',
      phone: passwordSeA.name,
      provinceValue: 0,
      deadline: '',
      radio: 0,
      publicTitle: '',
      showImgUpload: false,
      showAttachUpload: false,
      typeList: [],
      areaList: [],
      attachUploading: false,
      cityValue: 0,
      cityList: [],
      countyValue: 0,
      countyList: [],
      townValue: '',
      isCitySelf: true,
      isCountySelf: true
    }
  },
  mounted () {
    console.log('E', E)
    const that = this
    this.editor = new E('#wangeitor')
    this.editor.config.menus = [
      'head',
      'bold',
      'fontSize',
      'fontName',
      'italic',
      'underline',
      'strikeThrough',
      'indent',
      'lineHeight',
      'foreColor',
      'backColor',
      // 'link',
      'list',
      'justify',
      'quote',
      // 'emoticon',
      'image',
      // 'video',
      'table',
      // 'code',
      'splitLine',
      'undo',
      'redo'
    ]
    class imgMenu extends BtnMenu {
      constructor (editor) {
        const $elem = E.$(
          `<div class="w-e-menu" style="margin-right:8px;">
              <i class="el-icon-picture">图片</i>
          </div>`
        )
        super($elem, editor)
      }

      tryChangeActive () {}
      clickHandler () {
        // 做任何你想做的事情
        // 可参考【常用 API】文档，来操作编辑器
        that.showImgUpload = true
      }
    }
    this.editor.menus.extend('imgMenu', imgMenu)
    this.editor.config.menus = this.editor.config.menus.concat('imgMenu')
    class attachMenu extends BtnMenu {
      constructor (editor) {
        const $elem = E.$(
          `<div class="w-e-menu">
              <i class="el-icon-folder-opened">附件</i>
          </div>`
        )
        super($elem, editor)
      }

      tryChangeActive () {}
      clickHandler () {
        // 做任何你想做的事情
        // 可参考【常用 API】文档，来操作编辑器
        that.showAttachUpload = true
      }
    }
    this.editor.menus.extend('attachMenu', attachMenu)
    this.editor.config.menus = this.editor.config.menus.concat('attachMenu')
    this.editor.config.zIndex = 500
    this.editor.create()

    // const menu = new remote.Menu()
    // menu.append(new remote.MenuItem({ label: '复制(ctrl + c)', role: 'copy' }))
    // menu.append(new remote.MenuItem({ label: '粘贴(ctrl + v)', role: 'paste' }))
    // menu.append(new remote.MenuItem({ label: '剪切(ctrl + x)', role: 'cut' }))
    // document.querySelector('.public-title').addEventListener('contextmenu', (e) => {
    //   e.preventDefault()
    //   menu.popup(remote.getCurrentWindow())
    // }, false)
    // document.querySelector('.editor-wrap').addEventListener('contextmenu', (e) => {
    //   e.preventDefault()
    //   menu.popup(remote.getCurrentWindow())
    // }, false)

    api.getPublicClassList().then(res => {
      if (res.code === 200) {
        this.typeList = res.data
        if (!this.radio) this.radio = this.typeList[0].id
      }
    })
    api.cdIdentificationProvince({
      pid: 0
    }).then(res => {
      console.log(121342432)
      if (res.code === 200) {
        this.areaList = res.data
        if (!this.provinceValue) this.provinceValue = this.areaList[1].id
        this.isCitySelf = false
        api.cdIdentificationProvince({
          pid: 2
        }).then(res => {
          if (res.code === 200) {
            this.countyList = res.data
            this.countyValue = ''
          }
        })
      }
    })
  },
  activated () {
    this.status = '无限制'
    api.getUserInfo().then(res => {
      this.publicTitle = ''
      // this.cityValue = ''
      // this.countyValue = ''
      // this.townValue = ''
      this.id = ''
      this.editor.txt.html('')
      this.loading = this.$loading()
      api.newPublic({
        invitation: res.data.invitation,
        phone: this.phone,
        // phone: localStorage.getItem('user_phone').split('"')[1],
        // phone: localStorage.getItem('user_phone').split('"')[1] === null ? undefined : localStorage.getItem('user_phone').split('"')[1],
        userId: res.data.userId
      }).then(res => {
        this.loading && this.loading.close()
        if (res.code === 200 && res.data) {
          this.tips = res.name
          res.data.provinceValue && (this.provinceValue = res.data.provinceValue)
          res.data.cityValue && (this.cityValue = res.data.cityValue)
          res.data.countyValue && (this.countyValue = res.data.countyValue)
          res.data.townValue && (this.townValue = res.data.townValue)
          res.data.classa && (this.radio = res.data.classa)
          // this.deadline = res.data.deadline
          this.publicTitle = res.data.name
          this.id = res.data.id
          this.$nextTick(() => {
            this.editor.txt.html(res.data.content)
          })
        }
      })
    })
    // this.getUserId()
    // this.publicTitle = ''
    // this.id = ''
    // this.editor.txt.html('')
    // this.loading = this.$loading()
    // console.log(this.userId)
    // console.log(456)
    // api.newPublic({
    //   userId: this.userId
    // }).then(res => {
    //   this.loading && this.loading.close()
    //   if (res.code === 200 && res.data) {
    //     res.data.provinceValue && (this.provinceValue = res.data.provinceValue)
    //     res.data.classa && (this.radio = res.data.classa)
    //     this.publicTitle = res.data.name
    //     this.id = res.data.id
    //     this.$nextTick(() => {
    //       this.editor.txt.html(res.data.content)
    //     })
    //   }
    // })
  },
  methods: {
    handleImgChange (res) {
      this.editor.cmd.do('insertHTML', `<img src="${res.upload}" style="max-width:100%;"/>`)
      this.showImgUpload = false
    },
    handleAttachChange (res) {
      // 插入链接
      if (this.showAttachUpload) {
        this.editor.cmd.do('insertHTML', `<a class="attach-link" title="点击查看" href="${res.upload}"><img src="https://image.qsyhbgj.com/img-attach.png">${res.name}</a>`)
      } else if (this.$route.path === '/public') {
        this.notice = this.$notify({
          title: '提示',
          message: '附件上传完成,<span style="color: #409EFF;">点击插入</span>到编辑区域，或在已有素材选择后插入',
          dangerouslyUseHTMLString: true,
          duration: 0,
          onClick: () => {
            this.editor.cmd.do('insertHTML', `<a class="attach-link" title="点击查看" href="${res.upload}"><img src="https://image.qsyhbgj.com/img-attach.png">${res.name}</a>`)
            this.notice.close()
          }
        })
      }
      this.showImgUpload = false
      this.showAttachUpload = false
      this.attachUploading = false
    },
    searchArea (provinceValue) {
      if (this.provinceValue === 2 || this.provinceValue === 19 || this.provinceValue === 781 || this.provinceValue === 2221) {
        this.isCitySelf = false
        api.cdIdentificationProvince({
          pid: provinceValue
        }).then(res => {
          if (res.code === 200) {
            this.countyList = res.data
            this.countyValue = ''
          }
        })
      } else if (this.provinceValue === 3213 || this.provinceValue === 1) {
        this.isCitySelf = false
        this.isCountySelf = false
      } else {
        this.isCitySelf = true
        this.isCountySelf = true
        api.cdIdentificationProvince({
          pid: provinceValue
        }).then(res => {
          if (res.code === 200) {
            this.cityList = res.data
            // this.cityValue = this.cityList[0].city
            this.cityValue = ''
            this.countyValue = ''
          }
        })
      }
    },
    searchCounty (cityValue) {
      api.cdIdentificationProvince({
        pid: cityValue
      }).then(res => {
        if (res.code === 200) {
          this.countyList = res.data
          // this.countyValue = this.countyList[0].area
          this.countyValue = ''
        }
      })
      console.log('市区', cityValue)
    },
    doPublish () {
      if (!this.publicTitle || !this.editor.txt.html()) {
        this.$message({
          message: '请输入标题和内容！',
          type: 'warning'
        })
        return
      }
      if (!this.provinceValue) {
        this.$message({
          message: '请选择地区！',
          type: 'warning'
        })
        return
      }
      if (!this.townValue) {
        this.$message({
          message: '请选择并输入详细地址！',
          type: 'warning'
        })
        return
      }
      // if (!this.deadline) {
      //   this.$message({
      //     message: '请选择截止日期！',
      //     type: 'warning'
      //   })
      //   return
      // }
      this.loading = this.$loading()
      api.updatePublic({
        id: this.id,
        status: this.status,
        classa: this.radio,
        provinceValue: this.provinceValue,
        cityValue: this.cityValue,
        countyValue: this.countyValue,
        townValue: this.townValue,
        deadline: this.deadline,
        name: this.publicTitle,
        content: this.editor.txt.html(),
        isStorage: 1
      }).then(res => {
        this.loading && this.loading.close()
        if (res.code === 200) {
          // this.$confirm('通常3小时内审完，不会超过24小时。若急，请通过左下角联系我们立即审核。', '提交成功', {
          this.$confirm(res.message, '提交成功', {
            type: 'success',
            confirmButtonText: '前往查看',
            cancelButtonText: '继续公示'
          }).then(() => {
            this.$router.push('/personal-center?hash=public')
          }).catch(() => {
            this.$router.push('/public-list')
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.message || '请稍后再试'
          })
        }
      })
    },
    doSave () {
      this.loading = this.$loading()
      api.updatePublic({
        id: this.id,
        classa: this.radio,
        status: this.status,
        provinceValue: this.provinceValue,
        cityValue: this.cityValue,
        countyValue: this.countyValue,
        townValue: this.townValue,
        deadline: this.deadline,
        name: this.publicTitle,
        content: this.editor.txt.html(),
        isStorage: 0
      }).then(res => {
        this.loading && this.loading.close()
        if (res.code === 200) {
          this.$message({
            message: '已保存',
            type: 'success'
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.message || '请稍后再试'
          })
        }
      })
    }
  },
  components: {
    // myTitle,
    imgUplod,
    attachUpload
  }
}
</script>

<style lang="scss">
.public-page {
  .main-wraper {
    display: flex;
    flex-direction: column;
    .public-type {
      padding: 12px 12px 0;
    }
    .public-typeNew {
      padding: 12px 12px 0;
      display: flex;
    }
    .public-title {
      padding: 12px 12px 0;
      .el-input {
        width: 58%
      }
    }
    .public-tip {
      padding: 12px 12px 0;
      color: #83889a;
    }
    .public-tipA {
      padding: 12px 0 0 0;
      color: #83889a;
    }
    .editor-wrap {
      padding: 12px;
      flex: 1;
      height: 100px;
      #wangeitor {
        display: flex;
        flex-direction: column;
        height: 100%;
        .w-e-toolbar {
          .w-e-menu:nth-child(15) {
            display: none;
          }
        }
        .w-e-text ul {
          list-style-type: disc;
        }
        .w-e-text ol {
          list-style-type: decimal;
        }
        .w-e-text-container {
          flex: 1;
        }
        a {
          padding: 0 4px;
          img {
            width:14px;
            height:14px;
            vertical-align: text-bottom;
          }
        }
      }
    }
    .public-action {
      text-align: center;
      padding: 0 12px 12px;
    }
  }
}
</style>
